var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TooltipSideBar } from '../../app-builder/utils/tooltipConfig';
export var InfoTooltip = function (_a) {
    var info = _a.info, _b = _a.color, color = _b === void 0 ? '#000' : _b;
    return (_jsx(TooltipSideBar, __assign({ title: info }, { children: _jsx(FontAwesomeIcon, { icon: faInfoCircle, style: { cursor: 'pointer', fontSize: '14px' }, color: color }) })));
};
export var InfoTooltipSmall = function (_a) {
    var info = _a.info;
    return (_jsx(TooltipSideBar, __assign({ title: info }, { children: _jsx(FontAwesomeIcon, { color: "#828282", icon: faInfoCircle, style: { cursor: 'pointer', fontSize: '12px' } }) })));
};
export var QuestionTooltip = function (_a) {
    var info = _a.info;
    return (_jsx(TooltipSideBar, __assign({ title: info }, { children: _jsx(FontAwesomeIcon, { color: "#828282", icon: faQuestionCircle, style: { cursor: 'pointer', fontSize: '12px', margin: '3px' } }) })));
};
